export default __webpack_public_path__ + "static/premio1AR-d9ba71f7b6d30444d67b3e4fdf858365.png";